import { useQuery } from "react-query";

import { adminApis, queryKeys } from "./index";

export const useGetPotHistory = () => {
  return useQuery([queryKeys.JACKPOT_HISTORY], adminApis.getJackpotHistory, {
    keepPreviousData: true,
  });
};
